import * as React from 'react';
import useStyles from './use_styles';
import highContrastMediaQuery from '../../utils/high_contrast_media_query';
import { useTheme } from '@veneer/theme';
import Scrollbar from '../../scrollbar';

const OptionsList = React.forwardRef<
  HTMLUListElement,
  React.HTMLAttributes<HTMLUListElement>
>(({ children, ...props }, ref) => {
  const styles = useStyles();
  const theme = useTheme();
  return (
    <Scrollbar
      component="ul"
      css={[styles.root, highContrastMediaQuery(theme)]}
      hideFocusRing
      ref={ref}
      role="listbox"
      tabIndex={-1}
      {...props}
    >
      {children}
    </Scrollbar>
  );
});

OptionsList.displayName = 'OptionsList';

export default OptionsList;
